/**
* 生成订单
*/
<template>

  <div class="wrapper">

    <el-steps :active="2">
      <el-step title="生成订单"></el-step>
      <el-step title="支付订单"></el-step>
      <el-step title="支付成功"></el-step>
    </el-steps>

    <div class="head">
      <div class="head-title">
        请选择支付渠道
      </div>

      <div class="pay-wrapper">
        <div class="pay-logo" :class="  pay_index ==1 ? 'active':'' " @click="wechatPay()">
          <img class="wechat_pay_logo" src="@/assets/wechat.png"/>
          <div>使用微信付款</div>
          <div class="check"></div>
        </div>

        <div class="pay-logo" :class="  pay_index ==2 ? 'active':'' " @click="aliPay()">
          <img class="alipay_logo" src="@/assets/alipay.png"/>
          <div>使用支付宝付款</div>
          <div class="check"></div>
        </div>
      </div>

    </div>

    <div class="center">

      <img class="wechat_logo" src="@/assets/logo_wechatpay.png" :class="  pay_index ==2 ? 'hidden':'' ">
      <img class="zhifubao_logo" src="@/assets/zhifubao.png" :class="  pay_index ==1 ? 'hidden':'' ">

      <div class="content-wrapper">
        <div class="content-left">
          <div id="qrcode"></div>

          <div class="qrcode-tip">
            请使用{{ pay_index == 1 ? '微信' : '支付宝' }}扫一扫完成支付
          </div>
        </div>

        <div class="line"></div>

        <div class="content-right">

          <div class="title">
            中科劲点订单
          </div>
          <div class="price">
            ¥ {{ this.price }}
          </div>

          <div class="item-info">
            <div class="item-info-left">
              收款方
            </div>
            <div class="item-info-right">
              中科劲点(北京)科技有限公司
            </div>

          </div>

          <div class="item-info">
            <div class="item-info-left">
              下单时间
            </div>
            <div class="item-info-right">
              {{ this.orderTime }}
            </div>

          </div>

          <div class="item-info">
            <div class="item-info-left">
              订单号码
            </div>
            <div class="item-info-right">
              {{ this.orderNo }}
            </div>

          </div>

        </div>
      </div>


    </div>


  </div>


</template>


<script>

import QRCode from 'qrcodejs2'
import {createOrderApi, getOrderPayStatusApi} from "../../api/payMG";

export default {
  data() {
    return {
      pay_index: 1,
      userId: this.$store.getters.getUserInfo.userId,
      goodsId: "",
      orderNo: "",
      orderTime: "",
      price: "",
      timer: "",
      applicationId: ""
    }
  },
  methods: {
    wechatPay() {
      this.pay_index = 1;
      this.createOrder(this.pay_index, this.goodsId, this.userId, this.orderNo,this.applicationId);
    },
    aliPay() {
      this.pay_index = 2;
      this.createOrder(this.pay_index, this.goodsId, this.userId, this.orderNo,this.applicationId);
    },
    qrCode(url) {

      this.$nextTick(function () {
        document.getElementById("qrcode").innerHTML = "";
        let qrcode = new QRCode("qrcode", {
          width: 225,
          height: 225,
          text: url,
        });
      });
    },

    get() {

      getOrderPayStatusApi(this.orderNo).then(response => {
        if (response.status == 200) {
          this.$router.push("/pay/successPayOrder")
        }
      }).catch(e => {
        console.log(e)
      })

      console.log(Date.now());
    },

    createOrder(payType, goodsId, userId, orderNo,applicationId) {

      if (this.timer != "") {
        clearInterval(this.timer);
      }

      createOrderApi(
        {
          "payType": payType,
          "userId": userId,
          "goodsId": goodsId,
          "orderNo": orderNo,
          "applicationId":applicationId
        }
      ).then(response => {
        if (response.status != 200) {
          this.$message.warning(response.message);
          return;
        } else {
          this.qrCode(response.data.codeUrl);
          this.orderNo = response.data.orderNo;
          this.orderTime = response.data.createTime;
          this.price = response.data.price;

          this.timer = setInterval(this.get, 1000);

        }
      }).catch(e => {
        console.log(e)
        this.$message.error("网络异常请稍后重试");
      })
    }
  },
  created() {
    console.log(this.$route.query.goodsId);
    this.goodsId = this.$route.query.goodsId;
    this.applicationId = this.$route.query.applicationId;
    this.orderNo = this.$route.query.orderNo;
    if (this.$route.query.payIndex){
      this.pay_index = this.$route.query.payIndex;
    }


    this.createOrder(this.pay_index, this.goodsId, this.userId, this.orderNo,this.applicationId);
  },

  beforeDestroy() {
    clearInterval(this.timer);
  }

}


</script>

<style scoped>


.head {
  background-color: white;
}

.hidden {
  display: none;
}

.head-title {
  margin: 2vw 5vw;
  padding-top: 2vw;
}

.wrapper {
  padding: 2vw 3vw;
}

.qrcode {
  width: 16vw;
  height: 16vw;
}


.alipay_logo {
  width: 2.8vw;
  height: 2.8vw;
}

.wechat_pay_logo {
  width: 3vw;
  height: 3vw;
}

.pay-logo {
  display: flex;
  width: 18vw;
  justify-content: space-around;
  align-items: center;
  height: 5vw;
  margin-right: 2vw;

  cursor: pointer;
  box-shadow: 0 0 0.6vw rgb(0 0 0 / 10%);
}


.pay-wrapper {
  display: flex;
  margin-left: 5vw;
}


.line {
  width: 0vw;
  height: 18vw;
  border-left: 0.1vw dashed gray;

}


.center {
  background-color: white;
  height: 40vw;
}

.wechat_logo {
  margin-top: 5vw;
  margin-left: 10vw;
  width: 10vw;
  height: 3vw;
}

.zhifubao_logo {
  margin-top: 5vw;
  margin-left: 10vw;
  width: 10vw;
  height: 3.5vw;
}

.content-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5vw;
}

.content-left {
  width: 30vw;
  height: 20vw;
}

.content-right {
  width: 30vw;
  height: 20vw;
  margin-left: 10vw;
}


.qrcode-tip {
  margin-top: 0.8vw;
  margin-left: 0.8vw;

}

.content-right .title {
  font-size: 1.2vw;
}

.content-right .price {
  font-size: 3.5vw;
  font-weight: 400;
  margin: 1.2vw 0;
}

.item-info {
  display: flex;

}

.item-info-left {
  width: 10vw;
  margin: 0.5vw 0;
  color: gray;
}

.item-info-right {
  width: 20vw;
  margin: 0.5vw 0;
}

.pay-logo.active {
  border: 0.2vw #3a8ee6 solid;
  position: relative;
}

.pay-logo .check {
  width: 0;
  height: 0;
  border-bottom: 1.79vw solid #3a8ee6;
  border-right: 1.79vw solid transparent;
  position: absolute;
  left: -0.05vw;
  bottom: -0.05vw;
  display: none;
}

.pay-logo.active .check {
  display: block;
}

.pay-logo.active .check:before {
  content: "";
  width: 0.2vw;
  height: 1vw;
  background: white;
  left: 0.7vw;
  bottom: -2.05vw;
  position: absolute;
  transform: rotate(38deg);
  border-radius: 0.01vw;
}

.pay-logo.active .check:after {
  content: "";
  width: 0.21vw;
  height: 0.79vw;
  background: white;
  left: 0.17vw;
  bottom: -2.2vw;
  position: absolute;
  transform: rotate(-52deg);
  border-radius: 0.01vw;
}

</style>




// WEBPACK FOOTER //
// src/views/pay/PayOrder.vue